import { useEffect, useRef, useState } from "react";

export default function useSessionCountdown() {
  const [timeLeft, setTimeLeft] = useState("");
  const [reminderMinutes, setReminderMinutes] = useState(null);
  const shown10 = useRef(false);
  const shown3 = useRef(false);

  useEffect(() => {
    const expiryDateStr = sessionStorage.getItem("expiry");
    if (!expiryDateStr) return;

    const expiryDate = new Date(expiryDateStr).getTime();

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = expiryDate - now;

      if (diff <= 0) {
        clearInterval(interval);
        setTimeLeft("Expired");
        return;
      }

      const minutesLeft = diff / (1000 * 60);

      if (minutesLeft <= 10 && !shown10.current) {
        shown10.current = true;
        setReminderMinutes(10);
      } else if (minutesLeft <= 3 && !shown3.current) {
        shown3.current = true;
        setReminderMinutes(3);
      }

      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const resetReminder = () => setReminderMinutes(null);

  return { timeLeft, reminderMinutes, resetReminder };
}
